export const REDIRECT_LOCALSTORAGE_KEY = "customerportal:redirect";
